// TODO: update badge colors
export const COLOR_OPTIONS = [
  'stroll',
  'strollBright',
  'rubber',
  'branch',
  'tennis',
  'gray',
  'blue',
  'sky',
  'teal'
];

// BADGE
export const BADGE_COLOR_OPTIONS = {
  stroll: 'stroll',
  strollBright: 'strollBright',
  rubber: 'rubber',
  branch: 'branch',
  tennis: 'tennis',
  teal: 'teal',
  gray: 'gray',
  blue: 'blue',
  sky: 'sky'
};

export const BADGE_VARIANT_OPTIONS = {
  light: 'light',
  dark: 'dark',
  bright: 'bright'
};

export const BADGE_LIGHT_COLORS = {
  stroll: 'bg-stroll-light stroll-dark',
  rubber: 'bg-rubber-light rubber-dark',
  branch: 'bg-branch-light branch-dark',
  tennis: 'bg-tennis-light tennis-dark',
  teal: 'bg-teal-light forest-bright-600',
  gray: 'bg-passive secondary',
  blue: 'bg-cloud stone-700',
  sky: 'bg-sky midnight'
};

export const BADGE_DARK_COLORS = {
  stroll: 'bg-stroll stroll-light',
  rubber: 'bg-rubber-dark rubber-light',
  branch: 'bg-branch-dark branch-light',
  tennis: 'bg-tennis tennis-dark',
  gray: 'bg-default white',
  blue: 'bg-midnight cloud',
  sky: 'bg-royal-blue sky'
};

export const BADGE_BRIGHT_COLORS = {
  stroll: 'bg-stroll-dark stroll-light',
  rubber: 'bg-rubber rubber-light',
  branch: 'bg-branch branch-light',
  tennis: 'bg-tennis-dark tennis-light',
  // design system was updated with a new stroll color
  strollBright: 'bg-green-500-light teal-light'
};

export const BADGE_VARIANTS = {
  [BADGE_VARIANT_OPTIONS.light]: BADGE_LIGHT_COLORS,
  [BADGE_VARIANT_OPTIONS.dark]: BADGE_DARK_COLORS,
  [BADGE_VARIANT_OPTIONS.bright]: BADGE_BRIGHT_COLORS
};

export const BADGE_SIZE_OPTIONS = {
  default: 'default',
  small: 'small',
  xsmall: 'xsmall'
};

export const BADGE_SIZE_CLASSES = {
  [BADGE_SIZE_OPTIONS.default]: 'font-14',
  [BADGE_SIZE_OPTIONS.small]: 'font-12',
  [BADGE_SIZE_OPTIONS.xsmall]: 'font-12'
};

// BANNER
export const BANNER_COLORS = {
  stroll: 'bg-stroll-light b--stroll-light',
  rubber: 'bg-rubber-light b--rubber-light',
  branch: 'bg-branch-light b--branch-light',
  tennis: 'bg-tennis-light b--tennis-light',
  teal: 'bg-teal-light b--default',
  gray: 'bg-subtle-light-gray b--default',
  blue: 'bg-cloud b--cloud',
  sky: 'bg-sky b--sky',
  white: 'bg-white b--default', // not part of design system
  // looks different than the yellow banner in design system, but feel free to rename if this is what we're going with
  peach: 'bg-peach-300 b--peach-300'
};

export const BANNER_ICON_VARIANTS = {
  light: {
    stroll: 'bg-stroll stroll-light',
    rubber: 'bg-rubber rubber-light',
    branch: 'bg-branch branch-light',
    tennis: 'bg-tennis tennis-dark',
    teal: 'bg-green-500-light white',
    gray: 'bg-white ba b--default secondary',
    blue: 'bg-white ba b--default midnight',
    sky: 'bg-white ba b--default midnight'
  },
  dark: {
    stroll: 'bg-stroll-dark stroll-light',
    rubber: 'bg-rubber-dark rubber-light',
    branch: 'bg-branch-dark branch-light',
    tennis: 'bg-tennis-dark tennis-light',
    gray: 'bg-default white',
    blue: 'bg-midnight cloud',
    sky: 'bg-midnight sky',
    white: 'bg-subtle-gray stone-700', // not part of design system
    peach: 'bg-brown-dark-900 white' // not part of design system
  }
};

export const PILLS_VARIANT = {
  TEXT: 'text',
  PHOTO: 'photo',
  ICON: 'icon'
};
